import React, { Fragment, useState, useCallback, useRef } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { isPlainObject } from 'lodash';

import AutocompletePlacesField from './AutocompletePlacesField';

const style = {
  width: '100%',
  height: '200px',
  position: 'relative',
};

const CoordsField = ({ google, onChange, value, onBlur }) => {
  const [initCenter] = useState(
    value
      ? value
      : {
          lat: 13.7013318,
          lng: -89.2266226,
        },
  );
  const theMarker = useRef(null);

  const onMarkerDragEnd = useCallback(() => {
    if (theMarker?.current) {
      const position = theMarker.current.marker.position.toJSON();
      onChange(position);
      // onBlur();
    }
  }, [onChange, onBlur, theMarker]);

  const onSelect = useCallback(
    position => {
      onChange(position);
      onBlur();
    },
    [onChange, onBlur],
  );

  return (
    <Fragment>
      <AutocompletePlacesField onSelect={onSelect} />
      <Map
        fullscreenControl={false}
        mapTypeControl={false}
        streetViewControl={false}
        google={google}
        zoom={14}
        style={style}
        containerStyle={{ position: 'relative' }}
        initialCenter={value || initCenter}
        center={value || initCenter}
      >
        <Marker
          ref={theMarker}
          name="TheLocationMarker"
          draggable={true}
          position={value || initCenter}
          onDragend={onMarkerDragEnd}
        />
      </Map>
      {value && (
        <span className="text-gray-500 text-sm">
          <b>Latitude</b>: {value?.lat} &middot; <b>Longitude</b>: {value?.lng}
        </span>
      )}
    </Fragment>
  );
};

export default GoogleApiWrapper({
  apiKey: 'AIzaSyACUwmoq49MEbH0ZCm7ceqTAwdsYv5ibgM',
  className: 'test',
})(CoordsField);
